module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-10-5674d1b06d988749288ca9ce7aec92bc.jpg";